"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductListParams = void 0;
var _lodash = _interopRequireDefault(require("lodash.capitalize"));
var _zod = require("zod");
var _models = require("../models");
var _useTypedRouter = require("./useTypedRouter");
const lowerCaseValues = new Set(Object.values(_models.ProductListType).map((type)=>type.toLowerCase()));
const isProductListType = (value)=>lowerCaseValues.has(value.toLowerCase());
/* istanbul ignore next */ const routerSchema = _zod.z.object({
    productListId: _zod.z.string().optional(),
    productListType: _zod.z.enum([
        _models.ProductListType.Personal.toLowerCase()
    ]).optional().transform((value)=>(0, _lodash.default)(value)).catch((0, _lodash.default)(_models.ProductListType.Personal.toLowerCase()))
});
const useProductListParams = ()=>{
    const { query: { productListId, productListType } } = (0, _useTypedRouter.useTypedRouter)(routerSchema);
    return {
        productListId,
        productListType: isProductListType(productListType) ? productListType : _models.ProductListType.Personal
    };
};
exports.useProductListParams = useProductListParams;
